import {
  Box,
  Checkbox,
  CheckboxGroup,
  Flex,
  FormControl,
  FormErrorMessage,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field } from "formik";

export const RegularidadeAba = ({ children, props }) => {
  const desabilitarBotao =
    props?.values?.naturezaServico?.[0]?.length === 1 &&
    props?.values?.naturezaServico?.[0]?.[0]?.id === "publica";

  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Regularidade
        </Text>
        {children}
      </Flex>

      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Há Registro no CMDCA?"}
          mb={4}
        >
          Há Registro no CMDCA?
        </Text>

        <Field name="registroCMDCA">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.registroCMDCA && form.touched.registroCMDCA
              }
              id="registroCMDCA"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("registroCMDCA", value)
                }
                isDisabled={desabilitarBotao}
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox value="S">Sim</Checkbox>

                  <Checkbox value="N">Não</Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.registroCMDCA}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Há Registro Válido no CMDCA? "}
          mb={4}
        >
          Há Registro Válido no CMDCA?
        </Text>

        <Field name="registroValidoCMDCA">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.registroValidoCMDCA &&
                form.touched.registroValidoCMDCA
              }
              id="registroValidoCMDCA"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("registroValidoCMDCA", value)
                }
                isDisabled={desabilitarBotao}
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox value="S">Sim</Checkbox>

                  <Checkbox value="N">Não</Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.registroValidoCMDCA}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Há Inscrição no CMDCA?"}
          mb={4}
        >
          Há Inscrição no CMDCA?
        </Text>
        <Field name="inscricaoCMDCA">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.inscricaoCMDCA && form.touched.inscricaoCMDCA
              }
              id="inscricaoCMDCA"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("inscricaoCMDCA", value)
                }
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox value="S">Sim</Checkbox>

                  <Checkbox value="N">Não</Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.inscricaoCMDCA}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Há Inscrição Válida no CMDCA?"}
          mb={4}
        >
          Há Inscrição Válida no CMDCA?
        </Text>
        <Field name="inscricaoValidaCMDCA">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.inscricaoValidaCMDCA &&
                form.touched.inscricaoValidaCMDCA
              }
              id="inscricaoValidaCMDCA"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("inscricaoValidaCMDCA", value)
                }
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox value="S">Sim</Checkbox>

                  <Checkbox value="N">Não</Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.inscricaoValidaCMDCA}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Há Inscrição no CMAS? "}
          mb={4}
        >
          Há Inscrição no CMAS?
        </Text>

        <Field name="inscricaoCMAS">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.inscricaoCMAS && form.touched.inscricaoCMAS
              }
              id="inscricaoCMAS"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("inscricaoCMAS", value)
                }
                isDisabled={desabilitarBotao}
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox value="S">Sim</Checkbox>

                  <Checkbox value="N">Não</Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.inscricaoCMAS}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Há Inscrição Válida no CMAS?"}
          mb={4}
        >
          Há Inscrição Válida no CMAS?
        </Text>
        <Field name="inscricaoValidaCMAS">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.inscricaoValidaCMAS &&
                form.touched.inscricaoValidaCMAS
              }
              id="inscricaoValidaCMAS"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("inscricaoValidaCMAS", value)
                }
                isDisabled={desabilitarBotao}
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox value="S">Sim</Checkbox>

                  <Checkbox value="N">Não</Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.inscricaoValidaCMAS}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
    </>
  );
};
